import { Box, Typography } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { ReactComponent as Edit03Icon } from "components/Icons/edit-03.svg";
import { StatusValue } from "components/Table/StatusValue";
import { useMessage } from "hooks/intl";
import { useMemo } from "react";
import { AchievementFEFormat } from "types/achievements";
import { AchievementStepsIds, AchievementStepsUnion } from "types/stepper";
import { getStringValue } from "utilities/strings";
import { AchievementLimit } from "../../SingleAchievement/Limit";
import { useStyles } from "../AchievementForm.styles";
import {
  AchievementAvailability,
  DetailsList,
  prepareAchievementLimitToBEFormat,
} from "./helpers";

interface Props {
  errors?: any;
  data: AchievementFEFormat;
  skipToStep: (id: AchievementStepsUnion) => void;
}

export const BasicInfoSummary = ({ data, errors, skipToStep }: Props) => {
  const classes = useStyles();

  const { message } = useMessage();

  const achievementDetails = useMemo(
    () => [
      {
        left: message({ id: "achievementName" }),
        right: (
          <Typography>{getStringValue(data.translations[0]?.name)}</Typography>
        ),
        error: errors?.translations,
      },
      {
        left: message({ id: "achievementDescription" }),
        right: (
          <Typography>
            {getStringValue(data.translations[0]?.description)}
          </Typography>
        ),
      },
      {
        left: message({ id: "achievementAvailability" }),
        right: <AchievementAvailability {...data.activity} />,
        error: errors?.activity,
      },
      {
        left: message({ id: "achievementLimits" }),
        right: (
          <AchievementLimit
            {...prepareAchievementLimitToBEFormat(data?.limit)}
          />
        ),
        error: errors?.limit,
      },
      {
        left: message({ id: "achievementStatus" }),

        right: <StatusValue status={!!data?.active} />,
        rightClassName: classes.statusValue,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data],
  );

  return (
    <FormSection>
      <Box display="flex" justifyContent="space-between" mb={8}>
        <Typography fontWeight={500} mb={0}>
          {message({ id: "basicInfoSummary" })}
        </Typography>
        <Edit03Icon
          onClick={() => skipToStep(AchievementStepsIds.ACHIEVEMENT_INFO)}
          className={classes.editIcon}
        />
      </Box>
      <DetailsList detailsList={achievementDetails} />
    </FormSection>
  );
};
